import { createSlice } from '@reduxjs/toolkit';
import { IPublicWaterSystem } from '../../../types'
import {
  fetchPubWaterSystemAsyncBuilder,
  fetchPubWaterSystemAsync,
  fetchPWSEventMilestonesAsyncBuilder,
  fetchPWSEventMilestonesWDescAsyncBuilder,
  fetchPWSEventMilestonesAsync,
  fetchPWSEventMilestonesWDescAsync,
} from './asyncRequests'
import { IEventMilestone } from '../../../types/EventMilestone'



export interface PubWaterSystemInitialState {
  data: IPublicWaterSystem | null
  loading: boolean;
  error: string;
  selectedWaterSystem: string;
  eventMilestones: {
    data: IEventMilestone[],
    loading: boolean,
    error: string,
  }

}

const initialState: PubWaterSystemInitialState = {
  data: null,
  loading: false,
  error: '',
  selectedWaterSystem: "",
  eventMilestones: {
    data: [],
    loading: false,
    error: ""
  }
}

export const PubWaterSystemSlice = createSlice( {
  name: 'UtilitySlice',
  initialState,
  reducers: {
    resetWaterSystemMetricsData: (state) => {
      state.data = initialState.data
    },
    setSelectedWaterSystem: (state, action) => {
      state.selectedWaterSystem = action.payload
    },
  },
  extraReducers: (builder) => {
    fetchPubWaterSystemAsyncBuilder(builder);
    fetchPWSEventMilestonesAsyncBuilder(builder);
    fetchPWSEventMilestonesWDescAsyncBuilder(builder);
  },
})

export const PubWaterSystemActions = {
  ...PubWaterSystemSlice.actions,
  fetchPubWaterSystemAsync,
  fetchPWSEventMilestonesAsync,
  fetchPWSEventMilestonesWDescAsync
}

export const PubWaterSystemReducer = PubWaterSystemSlice.reducer;
